
export type ArticleCategory = 
  | 'lainaoppaat' 
  | 'asuntolainat' 
  | 'kulutusluotot' 
  | 'yrityslainat'
  | 'korot'
  | 'vastuullisuus'
  | 'all';

export interface Category {
  id: ArticleCategory;
  name: string;
  description?: string;
}

const categories: Category[] = [
  {
    id: 'all',
    name: 'Kaikki artikkelit',
    description: 'Kaikki artikkelit'
  },
  {
    id: 'lainaoppaat',
    name: 'Lainaoppaat',
    description: 'Yleisiä lainaoppaita eri tilanteisiin'
  },
  {
    id: 'asuntolainat',
    name: 'Asuntolainat',
    description: 'Asuntojen rahoittamiseen liittyvät artikkelit'
  },
  {
    id: 'kulutusluotot',
    name: 'Kulutusluotot',
    description: 'Kulutusluottoihin, pienlainoihin ja pikavippeihin liittyvät artikkelit'
  },
  {
    id: 'yrityslainat',
    name: 'Yrityslainat',
    description: 'Yrityslainoihin ja -rahoitukseen liittyvät artikkelit'
  },
  {
    id: 'korot',
    name: 'Korot',
    description: 'Korkoihin, kustannuksiin ja markkinanäkymiin liittyvät artikkelit'
  },
  {
    id: 'vastuullisuus',
    name: 'Vastuullisuus',
    description: 'Vastuulliseen lainaamiseen ja sijoittamiseen liittyvät artikkelit'
  }
];

export const getCategoriesArray = (): Category[] => {
  return categories;
};

export const getCategoryById = (id: ArticleCategory): Category | undefined => {
  return categories.find(category => category.id === id);
};

export const getCategoryName = (id: ArticleCategory): string => {
  const category = getCategoryById(id);
  return category ? category.name : 'Tuntematon kategoria';
};
